import {
    OPEN_SNACKBAR,
    CLOSE_SNACKBAR
} from './Types';
import { IUiAction, IUiReducerState } from './uiTypes';

const defaultState = {
    snackbarOpen: false,
    snackbarSeverity: 'info',
    snackbarMessage: ''
};

export default function reducer (state:IUiReducerState = defaultState, action: IUiAction) {
    switch (action.type) {
        case OPEN_SNACKBAR:
            return {
                ...state,
                snackbarOpen: true,
                snackbarSeverity: action.severity,
                snackbarMessage: action.message
            };
        case CLOSE_SNACKBAR:
            return {
                ...state,
                snackbarOpen: false
            };
        default:
            return state;
    }
}